import { UTSLocale } from "@smile2impress/attraction-constants";

import { UTSLocaleToCountryRegion } from "constants/enum";

export function mapLink(
    href: string | undefined,
    locale: UTSLocale
): string | undefined {
    if (!href) return undefined;
    const isAbsolute = /^(https?:|tel:|mailto:)/.test(href);
    return isAbsolute ? href : `/${UTSLocaleToCountryRegion[locale]}${href}`;
}
